import { Text, Badge, Stack } from '@mantine/core';

import { LABELS } from '../../../constants';
import { analyticsTypes } from '../../../types';
import { getCellValue, isEmptyKeywords } from '../../../utils/bot';

type Props = {
  row: analyticsTypes.RequestsTableRow;
  column: keyof analyticsTypes.RequestsTableRow;
};

const renderKeywords = (keywords: Record<string, number | string>) => {
  if (isEmptyKeywords(keywords)) {
    return <Text>{LABELS.EMPTY_CELL}</Text>;
  } else {
    const entries = Object.entries(keywords);
    const sortedEntries = entries.sort(([a], [b]) => {
      if (a === 'Всего') return 1;
      if (b === 'Всего') return -1;
      return 0;
    });

    return (
      <Stack>
        {sortedEntries.map(([keyword, count]) => (
          <Badge variant="light" color="violet" key={keyword} radius="md">
            {keyword}: {count}
          </Badge>
        ))}
      </Stack>
    );
  }
};

export const TableCellContent = ({ row, column }: Props) => {
  const value = getCellValue(row, column);

  // DEV-2833: two values per keyword — "leads arrived with the word" and
  // "received a spread". The difference = "keyword → spread" funnel losses.
  // Without newKeywordsBotArrived (server not deployed yet) fall through to
  // the old single-value rendering.
  if (column === 'newKeywordsBot' && row.newKeywordsBotArrived) {
    const arrived = row.newKeywordsBotArrived;
    const received = row.newKeywordsBot;
    const words = new Set([...Object.keys(arrived), ...Object.keys(received)]);
    return renderKeywords(
      Object.fromEntries(
        [...words].map((word) => [word, `${arrived[word] ?? 0} → ${received[word] ?? 0}`])
      )
    );
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return <Text>{value}</Text>;
  } else if (typeof value === 'object' && '_id' in value) {
    return <Text>{value._id}</Text>;
  } else {
    return renderKeywords(value);
  }
};
